module.exports = __webpack_public_path__ + "static/media/CDC-Mentions4-FR.f74cd2c3.jpg";